<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee">
            <div class="box-logo">
                <img src="@/assets/linelogin/logo-new-theme.svg" />
            </div>
            <div class="box-coffee">
                <img src="@/assets/linelogin/box-coffee-new-theme.svg" />
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
//service
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
//helper
import Account from "@/helper/AccountHelper.js";
import LineFunction from "@/helper/facade/LineFunction.js";
import CacheHelper from "@/helper/CacheHelper.js";
import PDPAHelper from "@/helper/PDPAHelper";

export default {
    name: "linelogin",
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            liffId: null,
        };
    },
    created: async function () {
        if (this.$route.query.debug) {
            this.initLiff();
        } else {
            await this.checkMaintenance();
            if (this.$route.name != "maintenance") {
                this.initLiff();
            }
        }
    },
    methods: {
        checkMaintenance() {
            return new Promise((resovle) => {
                BzbsApi.apiNestleMaintenance().subscribe(
                    (response) => {
                        if (response && response.length !== 0) {
                            this.$router.push("/maintenance");
                        }
                        resovle(response);
                    },
                    (err) => {
                        console.log(err);
                        resovle(err);
                    }
                );
            });
        },
        initLiff: function () {
            Vue.$cookies.remove("checkConsent");
            Vue.$cookies.remove("ref_code");
            Vue.$cookies.remove("ref_type");
            var lineFunction = new LineFunction();
            this.liffId = Vue.bzbsConfig.liffId;
            lineFunction
                .init(this.liffId)
                .then(() => {
                    var currentUrl = window.location.href;
                    if (lineFunction.isLogin()) {
                        if (lineFunction.isTokenExpire()) {
                            lineFunction.logout();
                            lineFunction.login(currentUrl);
                            return;
                        }

                        var idToken = lineFunction.getIdToken();
                        this.cacheHelper.setCache("linetoken", idToken);
                        if (idToken != null) {
                            this.apiLoginLine(idToken);
                        } else {
                            console.log("route", this.$route.query);
                            if (
                                this.$route.query["liff.state"] &&
                                this.$route.query["liff.state"].split("=")[0] ==
                                    "?target_page" &&
                                this.$route.query["liff.state"]
                                    .split("=")[1]
                                    .split("/")[0] == "getfriend"
                            ) {
                                this.$router.replace(
                                    this.$route.query["liff.state"].split(
                                        "="
                                    )[1]
                                );
                            } else {
                                this.$router.replace("/terms/term");
                            }
                        }
                    } else {
                        lineFunction.login(currentUrl);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    // this.$router.replace("/terms/term");
                    let dataerror = err
                        ? err.message
                            ? err.message
                            : "Error Liff-1"
                        : "Error Liff-2";
                    this.$router.replace({
                        name: "ErrorPage",
                        params: { data: dataerror },
                    });
                });
        },
        apiLoginLine: async function (idToken) {
            let termData = await PDPAHelper.getTermVersion();
            let privacyData = await PDPAHelper.getPrivacyVersion();
            return new Promise((resolve) => {
                BzbsAuth.apiLoginLineService(idToken).subscribe(
                    (data) => {
                        Account.setLogin(data, "data");
                        resolve(data, "data");
                        Account.apiGetProfileNestle().then((profile) => {
                            let matchTerm = true;
                            let matchPrivacy = true;
                            profile.SSOUser?.StreetCafeTermAndCondition !=
                            termData.terms.current_version
                                ? (matchTerm = false)
                                : (matchTerm = true);
                            profile.SSOUser?.StreetCafeDataPrivacy !=
                            privacyData.privacy.current_version
                                ? (matchPrivacy = false)
                                : (matchPrivacy = true);
                            if (!(matchPrivacy && matchTerm)) {
                                if (this.$route.query.target_page) {
                                    this.$router.push({
                                        name: "reconsent",
                                        query: {
                                            term: matchTerm,
                                            privacy: matchPrivacy,
                                            current_privacy:
                                                privacyData.privacy
                                                    .current_version,
                                            current_term:
                                                termData.terms.current_version,
                                            target_page:
                                                this.$route.query.target_page,
                                        },
                                    });
                                } else {
                                    this.$router.push({
                                        name: "reconsent",
                                        query: {
                                            term: matchTerm,
                                            privacy: matchPrivacy,
                                            current_privacy:
                                                privacyData.privacy
                                                    .current_version,
                                            current_term:
                                                termData.terms.current_version,
                                        },
                                    });
                                }
                            } else {
                                if (this.$route.query.target_page) {
                                    this.$router.push({
                                        path:
                                            "/" +
                                            this.$route.query.target_page.toLowerCase(),
                                    });
                                } else {
                                    this.$router.push("/privilege");
                                }
                            }
                        });
                    },
                    (err) => {
                        if (err.code == 401) {
                            BzbsAuth.apiGetMId(idToken).subscribe((data) => {
                                if (this.$route.query.target_page) {
                                    data.target_page =
                                        this.$route.query.target_page;
                                }
                                if (this.$route.query.reftype) {
                                    Vue.$cookies.set(
                                        "ref_type",
                                        this.$route.query.reftype
                                    );
                                }
                                if (this.$route.query.refcode) {
                                    Vue.$cookies.set(
                                        "ref_code",
                                        this.$route.query.refcode
                                    );
                                }
                                this.$router.push({
                                    name: "terms",
                                    params: { data: data },
                                });
                            });
                        } else if (err.code == 409 && err.id == 2128) {
                            this.$router.push({ name: "activeuser" });
                        } else {
                            let dataerror = err;
                            this.$router.replace({
                                name: "ErrorPage",
                                params: { data: dataerror },
                            });
                        }
                    }
                );
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper-bg {
    padding-bottom: 0;
    .coffee {
        min-height: 100vh;
    }
    .box-logo {
        width: 54%;
        position: fixed;
        top: 32%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        img {
            width: 100%;
        }
    }
    .box-coffee {
        width: 99.9%;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 1;
        img {
            width: 100%;
        }
    }
}
</style>
